import React, { useState } from "react";
import "./contact.css";
import BeatLoader from "react-spinners/BeatLoader";

function Contact(props) {
  const [result, setResult] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [subjectError, setSubjectError] = useState("");
  const [messageError, setMessageError] = useState("");

  const handleOnSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    if (validateForm()) {
      try {
        const response = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            name,
            email,
            subject,
            message,
            access_key: "00405bc6-7061-4b60-bb99-d3f56c8ab208",
          }),
        });
        const data = await response.json();
        console.log(data);
        if (data.success) {
          setResult("Form Submitted Successfully");
          event.target.reset();
        } else {
          console.log("Error", data);
          setResult(data.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
    setIsLoading(false);
  };

  const validateForm = () => {
    let isValid = true;

    if (!name.trim()) {
      setNameError("Please enter your name.");
      isValid = false;
    } else {
      setNameError("");
    }

    if (!email.trim()) {
      setEmailError("Please enter your email.");
      isValid = false;
    } else if (!isValidEmail(email.trim())) {
      setEmailError("Please enter a valid email address.");
      isValid = false;
    } else {
      setEmailError("");
    }

    if (!subject.trim()) {
      setSubjectError("Please enter the subject.");
      isValid = false;
    } else {
      setSubjectError("");
    }

    if (!message.trim()) {
      setMessageError("Please enter your message.");
      isValid = false;
    } else {
      setMessageError("");
    }

    return isValid;
  };

  const isValidEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  return (
    <section className="contact container section" id="contact">
      <h2 className="section__title">Get In Touch</h2>
      <div className="contact__container grid">
        <div className="contact__info">
          <h3 className="contact__title">Let's talk about everything!</h3>
          <p className="contact__details">
            Don't like forms? Send me an email.👋
          </p>
        </div>
        <form onSubmit={handleOnSubmit} className="contact__form">
          <div className="contact__form-group">
            <div className="contact__form-div">
              <input
                type="text"
                className="contact__form-input"
                placeholder="Insert your name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              {nameError && <div className="error-message">{nameError}</div>}
            </div>

            <div className="contact__form-div">
              <input
                type="email"
                className="contact__form-input"
                placeholder="Insert your email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {emailError && <div className="error-message">{emailError}</div>}
            </div>
          </div>

          <div className="contact__form-div">
            <input
              type="text"
              className="contact__form-input"
              placeholder="Insert your subject"
              required
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
            {subjectError && (
              <div className="error-message">{subjectError}</div>
            )}
          </div>

          <div className="contact__form-div contact__form-area">
            <textarea
              name=""
              id=""
              cols="30"
              rows="10"
              className="contact__form-input"
              placeholder="Write your message"
              required
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            {messageError && (
              <div className="error-message">{messageError}</div>
            )}
          </div>

          <button className="btn">
            {isLoading ? (
              <div style={{ display: "flex" }}>
                {" "}
                <BeatLoader size={10} color="#ffffff" />
              </div>
            ) : (
              "Send message"
            )}
          </button>
        </form>
      </div>
    </section>
  );
}

export default Contact;
